export const rolesEnum = {
  ADMIN: 'ADMIN',
  CP_ADMIN: 'CP_ADMIN',
  DS_ADMIN: 'DS_ADMIN',
  CAMPAIGN_ADMIN: 'CAMPAIGN_ADMIN',
};
